import { Calendar, Component, createElement, EventClickArg, EventMountArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { FormHelpers } from '../helpers/form-helpers';
import { Helpers } from '../helpers/helpers';
import { EventItem } from '../models/eventItem';
import { Tooltip } from "bootstrap";

export class EventCalendar {
	private calendar: Calendar; 
	public constructor() {
		const calendarEl = document.querySelector('.calendar') as HTMLElement;
		if (Helpers.isNullOrUndefined(calendarEl)) return;
		this.calendar = new Calendar(calendarEl, {
			plugins: [dayGridPlugin],
			eventDidMount: (info: EventMountArg) => {
				const tooltip = new Tooltip(info.el, {
					title: info.event.extendedProps.description,
					placement: 'top',
					trigger: 'hover',
					container: 'body',
					html:true
				});
			},
			eventClick: (e: EventClickArg) => {
				if (e.event.url && e.event.extendedProps.isExternal) {
					e.jsEvent.preventDefault();
					window.open(e.event.url, "_blank");
					return false;
				}
			}
		});

		this.calendar.render();
		this.loadEvents();

		this.setupCalendarActions();
	}

	public loadEvents(): void {
		const dateStr = this.calendar.getDate();
		const date = new Date(dateStr);
		const firstDay = Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
		const lastDay = Date.UTC(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);


		FormHelpers.postAjax({
			url: "/events/get-events",
			data: { startDate: new Date(firstDay), endDate: new Date(lastDay), culture: Helpers.getCurrentCulture() },
			success: (response) => {
				const events = response.results as EventItem[];
				let checkedFilters = document.querySelectorAll('.filter-list input[type=checkbox]:checked') as NodeListOf<HTMLInputElement>;
				let filterIds: string[] = [];
				checkedFilters.forEach(filter => {
					filterIds.push(filter.value);
				});

				this.calendar.removeAllEvents();
				events.forEach((event) => {
					let inCategory = filterIds.filter(id => event.categories.includes(id));
					if (filterIds.length > 0 && inCategory.length === 0) {
						return;
					}

					let description = `<strong>${event.name}</strong><br />${event.summary}`;
					if (event.location) {
						description += `<br /><strong>Location:</strong> ${event.location}`;
					}

					const endDate = new Date(event.endDate);
					// Set the time to the last minute of the day
					endDate.setHours(23, 59, 59, 999);

					this.calendar.addEvent({
						title: event.name,
						start: event.startDate,
						end: endDate,
						url: event.eventLink.replace('~', ''),
						overlap: true,
						description: description,
						isExternal: event.isExternalLink
				});
				});

			}, 
			error: (response) => {
				console.log(response);
			},
		});


	}


	setupCalendarActions(): void {
		const nextButton = document.querySelector('.fc-next-button');
		const previousButton = document.querySelector('.fc-prev-button');
		const filterCheckboxes = document.querySelectorAll('.filter-list input[type=checkbox]');
		nextButton.addEventListener('click',() => {
			this.loadEvents();
		});
		previousButton.addEventListener('click', () => {
			this.loadEvents();
		});

		filterCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener('click', e => {
					this.loadEvents();
				});
		});
	}
}

class CustomDayHeader extends Component<{ text: string }> {
	render() {
		return createElement('div', {}, '!' + this.props.text + '!')
	}
}